import { Grid } from './Grid';
import { GridItem } from './GridItem';
export const GridSystem = { Grid, GridItem };